import SectionHeading from '../common/SectionHeading';
import { steps } from '../../data/siteContent';

function ProcessSection() {
  return (
    <section className="block process-section">
      <div className="wrap">
        <SectionHeading eyebrow="HOW IT WORKS" title="상담은 이렇게 진행돼요">부담 갖지 마세요. 가입 권유부터 하지 않습니다.</SectionHeading>
        <div className="steps-grid">
          {steps.map(([title, body], index) => (
            <article className="step reveal" key={title}>
              <span>{String(index + 1).padStart(2, '0')}</span><h3>{title}</h3><p>{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProcessSection;
